import JumboScrollbar from '@jumbo/components/JumboScrollbar';
import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import { getDownloadFileName, getUploadFileFullPathDownload } from 'app/utils/appHelpers';
import config, { redColor, primaryColor } from 'config';
import { darken } from '@mui/material/styles';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import DshBoxTitle from '../Box/DshBoxTitle';
import IFrameLinkDialog from '../Dialog/IFrameLinkDialog';
import CustomTooltip from '../Tooltip/CustomTooltip';

function ReviewFileListTable({ meeting = {}, groupedData, grup = 5, type = 'dashboard', borderType = true, scroll = false, dataType = 'decisionFile' }) {
  const currentMeeting = useSelector(state => state.meeting.currentMeeting);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [iframeUrl, setIframeUrl] = useState('');

  const noBorderStyle = borderType ? {} : { border: 'none' };
  const imageExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.bmp', '.svg'];
  const linkColor = '#42a5f5'; // soft blue
  const hoverLinkColor = darken('#42a5f5', 0.2);

  const activeMeeting = meeting && meeting.id ? meeting : currentMeeting;
  const baseFolder = `meetingFiles/${activeMeeting.inst}-${activeMeeting.id}`;
  const apiBase = config.apiUrl + '/uploads/' + baseFolder;
  const openFile = async fileObj => {

    const meetingObj = Object.keys(meeting).length === 0 ? currentMeeting : meeting;

    const filename = fileObj.id + fileObj.ext;
    const downloadName = getDownloadFileName(meetingObj, fileObj);

    getUploadFileFullPathDownload(baseFolder, filename, downloadName);
  };

  const handleLinkClick = url => {
    setIframeUrl(url);
    setDialogOpen(true);
  };

  return (
    <div>
      {type !== 'preview' && (
        <DshBoxTitle
          color="subheader"
          title={
            dataType === 'link'
              ? (groupedData.length > 0 ? 'Bağlantılar' : 'Bağlantı bulunmamaktadır')
              : (groupedData.length > 0 ? 'Dosyalar' : 'Dosya bulunmamaktadır')
          }
        />
      )}

      {scroll ? (
        <JumboScrollbar autoHeight autoHeightMax="215px" autoHide autoHideDuration={200} autoHideTimeout={500} sx={{ mx: 5 }}>
          <Table size="small" sx={{ borderCollapse: 'collapse', width: '100%', tableLayout: 'fixed', backgroundColor: 'transparent', lineHeight: 1 }}>
            <TableBody>
              {groupedData.map((group, groupIndex) => (
                <React.Fragment key={groupIndex}>
                  <TableRow>
                    {group.map((item, itemIndex) => {
                      const isImage = imageExtensions.includes(item.ext.toLowerCase());
                      const fileUrl = `${apiBase}/${item.id}${item.ext}`;
                      const hasLink = item.fileInfo && item.ext === "";
                      const displayFileType = hasLink ? ` ${item.fileType}` : item.fileType + item.ext;
                      const linkUrl = hasLink ? item.fileInfo : fileUrl;

                      return (
                        <React.Fragment key={item.id}>
                          <TableCell style={{ padding: 8, width: 50, fontWeight: 400, color: redColor, ...noBorderStyle }}>
                            {hasLink ? `Bağlantı-${groupIndex * grup + itemIndex + 1}:` : `EK-${groupIndex * grup + itemIndex + 1}:`}
                          </TableCell>
                          <TableCell style={{ padding: 8, fontWeight: 400, ...noBorderStyle }}>
                            <CustomTooltip
                              title={isImage ? (
                                <div style={{ maxWidth: 300, maxHeight: 300, overflow: 'hidden' }}>
                                  <img
                                    src={fileUrl}
                                    alt="Preview"
                                    style={{ width: '100%', height: 'auto', objectFit: 'contain', backgroundColor: 'white', padding: 1 }}
                                  />
                                </div>
                              ) : hasLink ? 'Bağlantıyı görüntülemek için lütfen dokunun' : ''}
                              placement="right"
                              arrow
                              sx={{ maxWidth: 300, maxHeight: 300, '& .MuiTooltip-tooltip': { padding: 1, color: 'black' } }}
                            >
                              <a
                                href="#"
                                style={{
                                  textDecoration: 'none',
                                  color: hasLink ? linkColor : 'inherit',
                                  fontWeight: 400,
                                  padding: 8
                                }}
                                onMouseEnter={e => e.target.style.color = hasLink ? hoverLinkColor : redColor}
                                onMouseLeave={e => e.target.style.color = hasLink ? linkColor : 'inherit'}
                                onClick={e => {
                                  e.preventDefault();
                                  hasLink ? handleLinkClick(linkUrl) : openFile(item);
                                }}
                              >
                                {displayFileType}
                              </a>
                            </CustomTooltip>
                          </TableCell>
                        </React.Fragment>
                      );
                    })}
                    {Array(grup - group.length).fill(null).map((_, emptyIndex) => (
                      <React.Fragment key={`empty-${groupIndex}-${emptyIndex}`}>
                        <TableCell style={{ padding: 8, width: 50, ...noBorderStyle }} />
                        <TableCell style={{ padding: 8, ...noBorderStyle }} />
                      </React.Fragment>
                    ))}
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </JumboScrollbar>
      ) : (
        <Table size="small" sx={{ m: 0, p: 0, tableLayout: 'fixed', width: '100%', lineHeight: 1 }}>
          <TableBody>
            {groupedData.map((group, groupIndex) => (
              <React.Fragment key={groupIndex}>
                <TableRow>
                  {group.map((item, itemIndex) => {
                    const isImage = imageExtensions.includes(item.ext.toLowerCase());
                    const fileUrl = `${apiBase}/${item.id}${item.ext}`;
                    const hasLink = item.fileInfo && item.ext === "";
                    const displayFileType = hasLink ? ` ${item.fileType}` : item.fileType + item.ext;
                    const linkUrl = hasLink ? item.fileInfo : fileUrl;

                    return (
                      <React.Fragment key={item.id}>
                        <TableCell style={{ padding: 8, width: 50, fontWeight: 400, color: redColor, ...noBorderStyle }}>
                          {hasLink ? `Bağlantı-${groupIndex * grup + itemIndex + 1}:` : `EK-${groupIndex * grup + itemIndex + 1}:`}
                        </TableCell>
                        <TableCell style={{ padding: 8, fontWeight: 400, ...noBorderStyle }}>
                          <CustomTooltip
                            title={isImage ? (
                              <div style={{ maxWidth: 300, maxHeight: 300, overflow: 'hidden' }}>
                                <img
                                  src={fileUrl}
                                  alt="Preview"
                                  style={{ width: '100%', height: 'auto', objectFit: 'contain', backgroundColor: 'white', padding: 1 }}
                                />
                              </div>
                            ) : hasLink ? 'Bağlantıyı görüntülemek için lütfen dokunun' : ''}
                            placement="right"
                            arrow
                            sx={{ maxWidth: 300, maxHeight: 300, '& .MuiTooltip-tooltip': { padding: 1, color: 'black' } }}
                          >
                            <a
                              href="#"
                              style={{
                                textDecoration: 'none',
                                color: hasLink ? linkColor : 'inherit',
                                fontWeight: 400,
                                padding: 8
                              }}
                              onMouseEnter={e => e.target.style.color = hasLink ? hoverLinkColor : redColor}
                              onMouseLeave={e => e.target.style.color = hasLink ? linkColor : 'inherit'}
                              onClick={e => {
                                e.preventDefault();
                                hasLink ? handleLinkClick(linkUrl) : openFile(item);
                              }}
                            >
                              {displayFileType}
                            </a>
                          </CustomTooltip>
                        </TableCell>
                      </React.Fragment>
                    );
                  })}
                  {Array(grup - group.length).fill(null).map((_, emptyIndex) => (
                    <React.Fragment key={`empty-${groupIndex}-${emptyIndex}`}>
                      <TableCell style={{ padding: 8, width: 50, ...noBorderStyle }} />
                      <TableCell style={{ padding: 8, ...noBorderStyle }} />
                    </React.Fragment>
                  ))}
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      )}

      <IFrameLinkDialog open={dialogOpen} onClose={() => setDialogOpen(false)} iframeUrl={iframeUrl} />
    </div>
  );
}

export default ReviewFileListTable;
